<template>
  <div>
    <el-select v-model="conditionFunctionId" placeholder="请选择">
      <el-option
        v-for="item in valueOptions1"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="evaluateValueId"
      style="margin-left: 10px;"
      placeholder="请选择"
    >
      <el-option
        v-for="item in valueOptions2"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
    <el-button
      style="marginLeft:5px"
      icon="el-icon-delete"
      @click="deleteEvalItem()"
    ></el-button>
  </div>
</template>

<script>
export default {
  name: "evalItem",
  components: {},
  props: [
    "functionConditionValues",
    "evalItemObject",
    "combIndex",
    "itemIndex",
  ],
  data() {
    return {
      valueOptions1: [],
      valueOptions2: [],
      conditionFunctionId: null,
      evaluateValueId: null,
    };
  },
  watch: {
    conditionFunctionId: "changeValueOptions2",
    evaluateValueId: "initItemObject",
  },
  computed: {},
  methods: {
    deleteEvalItem(){
       this.$emit(
        "deleteEvalItem",
        this.$props.combIndex,
        this.$props.itemIndex
      );
    },
    initItemObject() {
      this.$props.evalItemObject.conditionFunctionId = this.conditionFunctionId;
      this.$props.evalItemObject.evaluateValueId = this.evaluateValueId;
      for (let index = 0; index < this.valueOptions2.length; index++) {
        let item = this.valueOptions2[index];
        if (item.id === this.evaluateValueId) {
          this.$props.evalItemObject.evaluateValueName = item.name;
        }
      }

      this.$emit(
        "getItemEvalValue",
        this.$props.combIndex,
        this.$props.itemIndex,
        this.$props.evalItemObject
      );
    },
    changeValueOptions2() {
      var val = this.conditionFunctionId;
      if (val != this.$props.evalItemObject.conditionFunctionId) {
        this.evaluateValueId = null;
      }
      if (this.valueOptions1 === null) {
        this.conditionFunctionId = null;
        this.evaluateValueId = null;
        return;
      }
      for (let index = 0; index < this.valueOptions1.length; index++) {
        let item = this.valueOptions1[index];
        if (item.id === val) {
          this.valueOptions2 = item.children;
          this.$props.evalItemObject.conditionFunctionName = item.name;
          break;
        }
      }
    },
  },
  created() {},
  mounted() {
    this.valueOptions1 = this.$props.functionConditionValues;
    this.conditionFunctionId = this.$props.evalItemObject.conditionFunctionId;
    this.evaluateValueId = this.$props.evalItemObject.evaluateValueId;
  },
};
</script>
<style lang="less" scoped></style>
